import { Svg } from 'components/svg'

export const IconPlay = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M15.308,9,.27,17.682V.318Z"
      transform="translate(4.73 3.682)"
      fill="currentColor"
    />
  </Svg>
)
